export interface Faq {
  q: string
  a: string[]
  list?: string[]
  afterList?: string
}

export const faqs: Faq[] = [
  {
    q: 'How do I receive Welding Instructor Atlas after purchasing?',
    a: ['You receive instant digital access to the materials after your payment is successfully completed.'],
  },
  {
    q: 'What format is it in?',
    a: [
      'All materials are delivered as PDF files. You can print them as handouts or show them on a tablet, screen or projector in your classroom, welding shop or training workshop.',
    ],
  },
  {
    q: 'Who is it for?',
    a: [
      'It is designed for welding instructors, technical and vocational schools, community college welding programs, apprenticeship and industry training centers, and experienced welders who teach. Adjust the content to your students, your level and your own curriculum.',
    ],
  },
  {
    q: 'What levels does it cover?',
    a: [
      'From beginner to advanced. Training pages include Easy, Standard and Advanced variants, so you can match each class to your students.',
    ],
  },
  {
    q: 'Does it work for beginner classes and advanced courses?',
    a: [
      'Yes. The material covers welding fundamentals and safety, MIG/MAG, TIG and stick welding, blueprints, welding symbols, inspection and quality control, and welding teaching methods, so it works for introductory shop classes, process-specific courses, certification-prep programs and short workshops alike.',
    ],
  },
  {
    q: 'Is it really a 100% visual system?',
    a: [
      'Yes. The six volumes contain 300 visual training pages (50 per volume). Each page includes an illustration or labeled diagram, a step-by-step breakdown when it applies, a ❌ common mistake vs. ✅ correct technique comparison, a teaching cue, a drill and a quick check. The five bonuses add practical teaching tools.',
    ],
  },
  {
    q: 'Does it include ready-to-teach lessons?',
    a: [
      'Yes. The system is built around a simple method — OPEN → CHOOSE → SHOW → TEACH — with lesson plans, demonstration guides, practice projects, drills and quick checks you can use right away.',
    ],
  },
  {
    q: 'What topics does it cover?',
    a: [
      'Welding fundamentals, safety, equipment and metal preparation; MIG/MAG welding, GMAW techniques and practical applications; TIG welding, GTAW techniques and precision fabrication; stick welding, SMAW processes and structural welding; welding blueprints, symbols, inspection and quality control; and welding instruction, workshop training and practical assessments.',
    ],
  },
  {
    q: 'Does it use inches or millimeters?',
    a: ['Both. Key dimensions are shown in inches and millimeters, for example 1/4 in (6.4 mm).'],
  },
  {
    q: 'Does it replace an accredited welding curriculum or certification?',
    a: [
      'No. This is educational teaching-support material for instructors. It does not replace an accredited welding curriculum, official certifications (for example AWS certification), welder qualification tests, your equipment manufacturer’s instructions, workplace safety training or qualified professional supervision. Always follow your institution’s safety procedures and the applicable codes, standards and WPS.',
      'Results depend on each instructor, student and learning context, so no specific results are guaranteed.',
    ],
  },
  {
    q: 'Does it include all six volumes?',
    a: ['Yes. The complete package includes all six visual welding technology and technical training volumes.'],
  },
  {
    q: 'Are the five bonuses included?',
    a: ['Yes. The five listed bonuses are included with the complete package at no additional cost under this offer.'],
  },
  {
    q: 'Does it include videos?',
    a: ['No. This is a digital educational resource package containing PDF materials. Videos are not included.'],
  },
  {
    q: 'Is the material in English?',
    a: ['Yes. The materials are written in English for an international audience.'],
  },
  {
    q: 'Can I edit the files?',
    a: ['The materials are provided as PDFs, not editable source files.'],
  },
  {
    q: 'Is this a one-time purchase?',
    a: ['Yes. The listed package is offered as a one-time payment, with no subscription.'],
  },
]
